































import _ from "lodash";
import { reactive, ref, Ref, SetupContext, defineComponent, onMounted, PropType, watch, computed } from '@vue/composition-api';
import { Prop, Component, Vue } from 'vue-property-decorator';
import * as D from "@/models/draggable";
import * as F from "@/formatter"

const edgeWidth = 5;

export default defineComponent({
  props: {
    node: {
      type: Object as PropType<D.GrabNode>,
      required: true,
    },
    status: {
      type: Object as PropType<D.GrabNodeStatus>,
      required: true,
    },
  },

  setup(prop: {
    node: D.GrabNode;
    status: D.GrabNodeStatus;
  }, context: SetupContext) {
    return {
      ...F.useFormatter(),
      
      resizer_binds: computed(() => {
        const node = prop.node;
        return [
          { class: "n",                         x: node.width/2 - edgeWidth, resizeVertical: "n", y:               - edgeWidth },
          { class: "nw", resizeHorizontal: "w", x:              - edgeWidth, resizeVertical: "n", y:               - edgeWidth },
          { class: "w",  resizeHorizontal: "w", x:              - edgeWidth,                      y: node.height/2 - edgeWidth },
          { class: "sw", resizeHorizontal: "w", x:              - edgeWidth, resizeVertical: "s", y: node.height   - edgeWidth },
          { class: "s",                         x: node.width/2 - edgeWidth, resizeVertical: "s", y: node.height   - edgeWidth },
          { class: "se", resizeHorizontal: "e", x: node.width   - edgeWidth, resizeVertical: "s", y: node.height   - edgeWidth },
          { class: "e",  resizeHorizontal: "e", x: node.width   - edgeWidth,                      y: node.height/2 - edgeWidth },
          { class: "ne", resizeHorizontal: "e", x: node.width   - edgeWidth, resizeVertical: "n", y:               - edgeWidth },
        ].map(d => ({ ...d, width: 2 * edgeWidth, height: 2 * edgeWidth }))
      }),

      node_bind: computed(() => {
        const node = prop.node;
        const r: any = {
          class: [],
          transform: `translate(${node.x},${node.y})`,
        };
        if (prop.status.selected) {
          r.class.push("selected");
        } else if (prop.status.reachable_from_selected) {
          r.class.push("reachable-from-selected")
        } else if (prop.status.reachable_to_selected) {
          r.class.push("reachable-to-selected")
        }
        if (prop.status.link_targeted) {
          r.class.push("link_targeted")
        }
        if (!prop.status.selected && prop.status.not_linkable_from_selected) {
          r.class.push("not_linkable_from_selected")
        }
        if (prop.status.overred) {
          r.class.push("overred");
          if (prop.status.selected && !prop.status.linkable_from_selected) {
            r.class.push("nonlinkable")
          }
        }
        if (prop.status.source_sink) {
          r.class.push(`${prop.status.source_sink}`);
        }
        return r;
      }),

      // handlers
      mouseDownBody(event: MouseEvent) {
        const node = prop.node;
        context.emit("nodeMouseDownBody", { event, node });
      },

      mouseDownResizer(event: MouseEvent, resizeVertical?: "n" | "s", resizeHorizontal?: "w" | "e") {
        const node = prop.node;
        context.emit("nodeMouseDownResizer", { event, node, resizeVertical, resizeHorizontal });
      },

      mouseEnter(event: MouseEvent) {
        const node = prop.node;
        if (!prop.status.overred) {
          context.emit("nodeMouseEnter", { event, node });
        }
      },

      mouseLeave(event: MouseEvent) {
        const node = prop.node;
        if (prop.status.overred) {
          context.emit("nodeMouseLeave", { event, node });
        }
      },
    }
  }
});
